import React from "react";
import { Link } from "react-router-dom";
import "./training-card.css";

export default function TrainingCard({
  title,
  heading,
  url,
  paragraph,
  preview,
  image,
  subcategories,
  handleClick,
  fromPage,
}: {
  title: string;
  heading: string;
  url: string;
  paragraph: string;
  preview: string;
  image: string;
  subcategories?: { title: string; subtitle: string; paragraph: string }[];
  handleClick: (title: string) => void;
  fromPage: boolean;
}) {
  return (
    <>
      <Link 
        to={`/training/${title.toLocaleLowerCase()}`} 
        state={{title,heading, url, paragraph, subcategories, image}} 
        className={`ae-training-card-container -shadow -hover-animation ${
              fromPage ? "-darker-theme" : "-light-theme"
        }`}
      >
        <div className="ae-training-card-text-container">
          <h2 className="ae-training-card-heading">{title}</h2>
          <p>{preview}</p>
          <p
            className={`${
              fromPage ? "-hidden" : "-visible"
            } ae-training-card-learn-more`}
          >
            Learn more
          </p>
        </div>
      </Link>
    </>
  );
}
